// @flow

import { datadogLogs } from '@datadog/browser-logs';

export type MemoryInfo = {
  jsHeapSizeLimit: number,
  totalJSHeapSize: number,
  usedJSHeapSize: number,
};

/**
 * Performance wraps methods from the performance API
 * as some of them can throw runtime exceptions.
 */
export const performance = {
  now(): number {
    return window.performance.now();
  },
  mark(name: string): void {
    window.performance.mark(name);
  },
  measure(name: string, startMark?: string, endMark?: string): void {
    try {
      window.performance.measure(name, startMark, endMark);
    } catch (e) {
      console.error(e);
      datadogLogs.logger.error('[performance] Error occurred while measuring performance', {}, e);
    }
  },
  clearMarks(markName?: string): void {
    window.performance.clearMarks(markName);
  },
  clearMeasures(measureName?: string): void {
    window.performance.clearMeasures(measureName);
  },
  getEntriesByName(name: string, type?: string): PerformanceEntryList {
    return window.performance.getEntriesByName(name, type);
  },
  getEntriesByType(type: string): PerformanceEntryList {
    return window.performance.getEntriesByType(type);
  },
  memory(): ?MemoryInfo {
    return window.performance.memory;
  },
};
